module.exports = __webpack_public_path__ + "img/location.0f047ce1.jpg";